import './ForcedPaywall.sass';

import React, { FC, useCallback, useEffect, useMemo, useState } from 'react';
import { useRouter } from 'react-router5';
import { useDispatch, useSelector } from 'react-redux';

import { Button, ScrollView } from '$uikit';
import { Api } from '$api';
import { setSubscriptionAuthor } from '$utils/subscriptionAuthor';
import { AuthPopoverState } from '$store/models';
import { useCurrentUserInfo, useTranslator } from '$hooks';
import { formatCurrency, statReachGoal } from '$utils';
import { profileActions } from '$store/profile';
import { authSelector } from '$store/auth';
import { AuthPopoverSimple } from '$core/AuthPopover/AuthPopover';
import { mainActions } from '$store/main';
import { SUBSCRIPTION_ADULT } from '$shared/constants/pages';

export const ForcedPaywall: FC = () => {
  const [price, setPrice] = useState({ ton: 0, eur: 0 });
  const t = useTranslator();
  const dispatch = useDispatch();
  const { isLogged } = useSelector(authSelector);
  const router = useRouter();
  const user = useCurrentUserInfo();

  useEffect(() => {
    statReachGoal('forced_paywall');
  }, []);

  const handleLoad = useCallback(() => {
    Api.get('/balance/subscription/common/adult')
      .then((data: any) => {
        setSubscriptionAuthor(data.user);
        setPrice({
          ton: data.price,
          eur: data.eurPrice,
        });
      })
      .catch(() => {
        setTimeout(() => handleLoad(), 1000);
      });
  }, []);

  useEffect(() => {
    handleLoad();
  }, []);

  const handleJoin = useCallback(() => {
    // if (!price.eur) {
    //   return;
    // }

    if (isLogged) {
      // dispatch(
      //   balancePayActions.open({
      //     amount: +price.eur,
      //     action: BalancePayAction.SUBSCRIPTION_ADULT,
      //     objectId: SubscriptionType.Adult,
      //   }),
      // );
      // router.navigate(SUBSCRIPTION_FIAT, {
      //   category: 1,
      // });
      router.navigate(SUBSCRIPTION_ADULT, {
        category: 1,
      });
      statReachGoal('show_paywall_from_forced_paywall');
    } else {
      dispatch(profileActions.setAuthPopoverState(AuthPopoverState.LOGIN));
    }
    statReachGoal('forced_paywall_join');
  }, [price, isLogged]);

  const handleSkip = useCallback(() => {
    statReachGoal('forced_paywall_skip');
    dispatch(mainActions.setFeatureAsShown('eroticSubscription'));
  }, [price, isLogged]);

  const buttonText = useMemo(() => {
    return t('forced_paywall_btn_old');
    // return t('forced_paywall_btn', {
    //   price: formatCurrency(price.eur, CurrencyEnum.EUR),
    // });
  }, [price]);

  const texts = useMemo(() => {
    if (!user || user.id % 2 === 1) {
      return {
        title: t('forced_paywall_title_test'),
        caption: t('forced_paywall_caption_test'),
        button: t('forced_paywall_btn_test'),
      };
    } else {
      return {
        title: t('forced_paywall_title'),
        caption: t('forced_paywall_caption'),
        button: t('forced_paywall_btn_old'),
      };
    }
  }, [user, t]);

  return (
    <ScrollView>
      <div className="ForcedPaywall">
        <div className="ForcedPaywall__icon">
          <video
            autoPlay
            loop
            playsInline
            className="ForcedPaywall__icon__video"
            poster="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII"
            preload="auto"
            muted
            disableRemotePlayback
          >
            <source src={require('./assets/dimond.mp4').default} type="video/quicktime" />
            <source src={require('./assets/dimond.webm').default} type="video/webm" />
          </video>
          <div className="ForcedPaywall__icon__bg" />
        </div>
        <div className="ForcedPaywall__title">{texts.title}</div>
        <div className="ForcedPaywall__caption">{texts.caption}</div>
        <div className="ForcedPaywall__btn">
          <Button onClick={handleJoin} stretched>
            {texts.button}
            {/*{price.eur ? buttonText : <Loader />}*/}
          </Button>
          <Button onClick={handleSkip} mode="secondary" stretched>
            {t('forced_paywall_skip')}
          </Button>
        </div>
      </div>
      <AuthPopoverSimple />
    </ScrollView>
  );
};
